import { render } from "./Sac.vue?vue&type=template&id=1031c79e"
import script from "./Sac.vue?vue&type=script&setup=true&lang=js"
export * from "./Sac.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"source/js/vue/pages/Sac.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1031c79e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1031c79e', __exports__)) {
    api.reload('1031c79e', __exports__)
  }
  
  module.hot.accept("./Sac.vue?vue&type=template&id=1031c79e", () => {
    api.rerender('1031c79e', render)
  })

}


export default __exports__